import { ref, computed, watch, useDebounceFn } from '#imports'

export const useSaferGamblingSearch = () => {
    const searchQuery = ref('')
    const isLoading = ref(false)
    const searchResults = ref<Array<Record<string, unknown>>>([])
    const { searchByTitle } = useLayeredContent()

    const performSearch = useDebounceFn(async (term: string) => {
        if (!term || term.length < 2) {
            searchResults.value = []
            isLoading.value = false
            return
        }

        isLoading.value = true
        try {
            searchResults.value = await searchByTitle('safer-gambling/qas', term)
        }
        catch {
            searchResults.value = []
        }
        finally {
            isLoading.value = false
        }
    }, 300)

    watch(searchQuery, (value) => {
        if (value.length >= 2) {
            isLoading.value = true
            performSearch(value)
        }
        else {
            searchResults.value = []
        }
    })

    const searchMappedResults = computed(() =>
        searchResults.value.map(qa => ({
            id: ((qa.stem as string) || '').split('/').pop() || '',
            title: qa.title as string,
            body: (qa.description as string) || '',
        }))
    )

    return { searchQuery, searchResults, searchMappedResults, isLoading }
}
